import styled from "styled-components";
import { theme } from "theme";

export const FooterInputWrapper = styled.div`
  display: flex;
  gap: 2rem;
  & > *:first-child {
    width: 70%;
  }
  & > *:last-child {
    width: 30%;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  & > div {
    width: 14px;
    height: 14px;
    border-radius: 999px;
    background-color: ${(props) => props.color};
  }
`;

export const DownloadLink = styled.a`
  color: #d3301a;
  text-decoration: underline;
  font-size: 14px;
  font-family: "Inter";
  font-weight: 500;
`;

export const UploadDocumentButton = styled.button`
  background-color: ${theme.accentColor};
  color: white;
  outline: none;
  padding: 1rem 2rem;
  border: none;
  font-family: "Inter";
  font-weight: 500;
  border-radius: 10px;
`;

export const DownloadTemplateWrapper = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const ErrorDownloadLink = styled.a`
  color: #fc6868;
  font-family: "Inter";
  text-decoration: underline;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  &:hover {
    cursor: pointer;
  }
`;
export const FileDownloadLink = styled.a`
  color: ${theme.linkColor};
  font-family: "Inter";
  font-weight: 500;
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
`;

export const CutoffDateDivider = styled.div`
  margin-top: 4rem;
  width: calc(100% + 80px);
  margin-left: -40px;
  height: 14px;
  background-color: #e4e4e4;
`;
